<template>
  <v-container id="bid-paperwork" fluid tag="section" class="main-container">
    <idc-component-bid-paperwork
      :settings="settings"
      :can-edit="canEdit"
      :can-read="canRead"
      :can-delete="canDelete"
      :url-specification="urlSpecification"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardBidPaperwork',
    components: {
      IdcComponentBidPaperwork: () => import('@/components/idc/bids/Paperwork'),
    },
    props: {
      canEdit: {
        type: Boolean,
        default: () => true,
      },
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canDelete: {
        type: Boolean,
        default: () => true,
      },
      urlSpecification: {
        type: String,
        default: () => Path.SALES_BIDS_SPEC,
      },
      urlSummary: {
        type: String,
        default: () => Path.SALES_BIDS_SUMMARY,
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
